import { featuredPropertiesAction } from 'redux/actions/propertiesActions';

const defaultState = {
    properties: [],
    areLoading: false,
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case featuredPropertiesAction.REQUEST:
            return {
                ...state,
                areLoading: true,
            };
        case featuredPropertiesAction.SUCCESS:
            return {
                ...state,
                properties: action.payload,
            };
        case featuredPropertiesAction.FULFILL:
            return {
                ...state,
                areLoading: false,
            };
        default:
            return {
                ...state,
            };
    }
};
